export default __webpack_public_path__ + "static/media/audi.39cf8cf3.svg";